import {createContext} from "react";

const pathRegex = /(?:https?:\/\/[^/]*)(\/(?:$|.*?\/$))/;
const match = window.location.href.match(pathRegex);
const context_path = match ? match[1] || '' : '';
const Url = createContext(context_path)

export default Url;

// const test = "http://49.247.6.65/mconweb/"
// const pathRegex = /(?:https?:\/\/[^/]*)(\/(?:$|.*?\/$))/;
// const matchTest = test.match(pathRegex);
// const test_context_path = matchTest ? matchTest[1] || '' : '';
// const Url = createContext(test_context_path)
//
// export default Url;